export interface IPublicTransportConstants {
  singleTicketOneZonePriceInSek: number;
  singleTicketTwoZonesPriceInSek: number;
  singleTicketThreeZonesPriceInSek: number;
  dayTicketOneZonePriceInSek: number;
  dayTicketTwoZonesPriceInSek: number;
  dayTicketThreeZonesPriceInSek: number;
  threeDaysTicketOneZonePriceInSek: number;
  threeDaysTicketTwoZonesPriceInSek: number;
  threeDaysTicketThreeZonesPriceInSek: number;
  periodTicket30DaysOneZonePriceInSek: number;
  periodTicket30DaysTwoZonesPriceInSek: number;
  periodTicket30DaysThreeZonesPriceInSek: number;
  periodTicket90DaysOneZonePriceInSek: number;
  periodTicket90DaysTwoZonesPriceInSek: number;
  periodTicket90DaysThreeZonesPriceInSek: number;
  periodTicket365DaysOneZonePriceInSek: number;
  periodTicket365DaysTwoZonesPriceInSek: number;
  periodTicket365DaysThreeZonesPriceInSek: number;
}

export const PublicTransportConstants: IPublicTransportConstants = {
  singleTicketOneZonePriceInSek: 37,
  singleTicketTwoZonesPriceInSek: 74,
  singleTicketThreeZonesPriceInSek: 111,
  dayTicketOneZonePriceInSek: 120,
  dayTicketTwoZonesPriceInSek: 240,
  dayTicketThreeZonesPriceInSek: 360,
  threeDaysTicketOneZonePriceInSek: 240,
  threeDaysTicketTwoZonesPriceInSek: 480,
  threeDaysTicketThreeZonesPriceInSek: 720,
  periodTicket30DaysOneZonePriceInSek: 860,
  periodTicket30DaysTwoZonesPriceInSek: 1295,
  periodTicket30DaysThreeZonesPriceInSek: 1980,
  periodTicket90DaysOneZonePriceInSek: 2320,
  periodTicket90DaysTwoZonesPriceInSek: 3495,
  periodTicket90DaysThreeZonesPriceInSek: 5345,
  periodTicket365DaysOneZonePriceInSek: 8600,
  periodTicket365DaysTwoZonesPriceInSek: 12950,
  periodTicket365DaysThreeZonesPriceInSek: 19800,
};
